module.exports = __webpack_public_path__ + "img/icon-card.b194bd56.svg";